import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";
import OpisModal from "./OpisModal";
import CustomCalendarInput from "../CustomCalendarInput";
import { formatDate } from "../../../../utils/formatDate";
import LZOModal from "./LZOModal";
import CustomSelectMultiple from "../../globalno-dodavanje/CustomSelectMultiple";
import MereModal from "./mere/MereModal";
import RiziciModal from "./RiziciModal";
import UputstvaModal from "./UputstvaModal";
import Obrazac6Prikaz from "./Obrazac6Prikaz";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";

const OPIS = "- ОПИС";
const UPUTSTVA = "- Упутство 1";

const razloziAll = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"];

const emptyNewData = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  razlog: "",
  opis: "",
  teorijaDatum: formatDate(new Date()),
  praksaDatum: formatDate(new Date()),
  testDatum: formatDate(new Date()),
  zapisnikDatum: formatDate(new Date()),
  lzo: [],
  lzoDatum: "",
  prati: [],
  mere: [],
  rizici: "",
  uputstva: "",
};

const parseDateForApi = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return null;
  const y =
    parts[2].length === 2
      ? (parseInt(parts[2]) < 50 ? "20" : "19") + parts[2]
      : parts[2];
  return `${y}-${parts[1]}-${parts[0]}`;
};

function Dodavanje({ handleZatvori, editData, sacuvajAzurirano, lookups }) {
  const [newData, setNewData] = useState(emptyNewData);
  const [openModal, setOpenModal] = useState("");

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const filteredZaposleni =
    newData.radnoMesto.id === -1
      ? lookups.zaposleni || []
      : (lookups.zaposleni || []).filter(
          (z) => String(z.workplace_id) === String(newData.radnoMesto.id),
        );

  const filteredRadnaMesta =
    newData.zaposlen.id === -1
      ? lookups.radna_mesta || []
      : (lookups.radna_mesta || []).filter((rm) => {
          const zaposlen = (lookups.zaposleni || []).find(
            (z) => String(z.id) === String(newData.zaposlen.id),
          );
          return zaposlen
            ? String(rm.id) === String(zaposlen.workplace_id)
            : true;
        });

  useEffect(() => {
    if (editData) {
      setNewData({
        ...editData,
        radnoMesto: {
          id: editData.workplace_id,
          name: editData.radno_mesto_naziv || editData.radnoMesto?.name || "",
        },
        zaposlen: {
          id: editData.employee_id,
          name: editData.zaposleni_naziv || editData.zaposlen?.name || "",
        },
        teorijaDatum: editData.teorija_datum_fmt || editData.teorijaDatum || "",
        praksaDatum: editData.praksa_datum_fmt || editData.praksaDatum || "",
        testDatum: editData.test_datum_fmt || editData.testDatum || "",
        zapisnikDatum:
          editData.zapisnik_datum_fmt || editData.zapisnikDatum || "",
        lzoDatum: editData.lzo_datum_fmt || editData.lzoDatum || "",
        lzo: editData.lzo || [],
        prati: editData.prati || [],
        mere: (editData.mere || []).map((m) => ({
          ...m,
          text: m.text_content || m.text || "",
        })),
      });
    } else {
      setNewData((prev) => ({ ...prev, opis: OPIS, uputstva: UPUTSTVA }));
    }
  }, [editData]);

  const handleRadnoMestoChange = (rm) => {
    setNewData((prev) => {
      const rmData = (lookups.radna_mesta || []).find(
        (r) => String(r.id) === String(rm.id),
      );
      const noviRizici = rmData?.rizici || prev.rizici;
      const noviOpis =
        rmData?.opis_poslova !== undefined ? rmData.opis_poslova : prev.opis;
      const zaposlenStillValid =
        prev.zaposlen.id === -1 ||
        (lookups.zaposleni || []).some(
          (z) =>
            String(z.id) === String(prev.zaposlen.id) &&
            String(z.workplace_id) === String(rm.id),
        );
      return {
        ...prev,
        radnoMesto: rm,
        rizici: noviRizici,
        opis: noviOpis,
        zaposlen: zaposlenStillValid ? prev.zaposlen : { id: -1, name: "" },
      };
    });
  };

  const handleZaposlenChange = (z) => {
    const zaposlenData = (lookups.zaposleni || []).find(
      (emp) => String(emp.id) === String(z.id),
    );
    if (zaposlenData?.workplace_id) {
      const rm = (lookups.radna_mesta || []).find(
        (r) => String(r.id) === String(zaposlenData.workplace_id),
      );
      if (rm) {
        setNewData((prev) => ({
          ...prev,
          zaposlen: z,
          radnoMesto: { id: rm.id, name: rm.name },
          rizici: rm.rizici || prev.rizici,
          opis: rm.opis_poslova !== undefined ? rm.opis_poslova : prev.opis,
        }));
        return;
      }
    }
    setNewData((prev) => ({ ...prev, zaposlen: z }));
  };

  useEffect(() => {
    if (newData.lzo.length === 0) {
      setNewData((prev) => ({ ...prev, lzoDatum: "" }));
      return;
    }
    if (!newData.lzoDatum)
      setNewData((prev) => ({ ...prev, lzoDatum: formatDate(new Date()) }));
  }, [newData.lzo]);

  const handleChange = (newValue, field) => {
    setNewData((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSacuvaj = async () => {
    const payload = {
      company_id: selectedMainEntity.company_id,
      employee_id: newData.zaposlen.id,
      workplace_id: newData.radnoMesto.id,
      razlog: newData.razlog,
      opis: newData.opis,
      teorija_datum: parseDateForApi(newData.teorijaDatum),
      praksa_datum: parseDateForApi(newData.praksaDatum),
      test_datum: parseDateForApi(newData.testDatum),
      zapisnik_datum: parseDateForApi(newData.zapisnikDatum),
      lzo_datum: parseDateForApi(newData.lzoDatum),
      rizici: newData.rizici,
      uputstva: newData.uputstva,
      lzo: newData.lzo,
      prati: newData.prati,
      mere: newData.mere,
    };

    try {
      if (editData?.id) {
        const { data } = await axios.post(`${baseUrl}/evidencija6/update.php`, {
          ...payload,
          id: editData.id,
        });
        if (data.status === 200) {
          if (sacuvajAzurirano) sacuvajAzurirano();
          handleZatvori();
        }
      } else {
        const { data } = await axios.post(
          `${baseUrl}/evidencija6/create.php`,
          payload,
        );
        if (data.status === 200) {
          if (sacuvajAzurirano) sacuvajAzurirano();
          handleZatvori();
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleCancelModal = () => setOpenModal("");

  const onChangePrati = (newValue) => {
    const newValues = newData.prati.find((d) => d.id === newValue.id)
      ? newData.prati.filter((d) => d.id !== newValue.id)
      : [...newData.prati, newValue];
    setNewData((prev) => ({ ...prev, prati: newValues }));
  };

  const isDisabled =
    newData.radnoMesto.id == -1 || newData.zaposlen.id == -1 || !newData.razlog;

  return (
    <>
      <div
        style={{
          overflowY: "auto",
          height: `calc(100% - 240px)`,
          background: "white",
          padding: "40px",
          border: "1.5px solid #9f9f9f",
        }}
      >
        <Obrazac6Prikaz data={newData} />
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexDirection: "column",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "15vw" }}>
            <CustomSelect
              label={dictionary["radnoMesto"]}
              allValues={filteredRadnaMesta}
              selectedValue={newData.radnoMesto}
              onSelectChange={handleRadnoMestoChange}
            />
          </div>
          <div style={{ width: "15vw" }}>
            <CustomSelect
              label={dictionary["imeIPrezime"]}
              allValues={filteredZaposleni}
              selectedValue={newData.zaposlen}
              onSelectChange={handleZaposlenChange}
            />
          </div>
          <div
            onClick={() => setOpenModal("OPIS")}
            style={{ alignContent: "end" }}
          >
            <Button
              active={openModal === "OPIS"}
              style={{
                padding: "0 10px",
                width: "15vw",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              {dictionary["opis"]}
            </Button>
          </div>
          <CustomSelectSimple
            label={dictionary["razlog"]}
            allValues={razloziAll}
            selectedValue={newData.razlog}
            onSelectChange={(v) => handleChange(v, "razlog")}
            style={{ width: "5vw" }}
            isUp
          />
          <CustomCalendarInput
            label={dictionary["teorija"]}
            value={newData.teorijaDatum}
            onChange={(v) => handleChange(v, "teorijaDatum")}
          />
          <CustomCalendarInput
            label={dictionary["praksa"]}
            value={newData.praksaDatum}
            onChange={(v) => handleChange(v, "praksaDatum")}
          />
          <CustomCalendarInput
            label={dictionary["test"]}
            value={newData.testDatum}
            onChange={(v) => handleChange(v, "testDatum")}
          />
          <CustomCalendarInput
            label={dictionary["zapisnik"]}
            value={newData.zapisnikDatum}
            onChange={(v) => handleChange(v, "zapisnikDatum")}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <div
            onClick={() => setOpenModal("LZO")}
            style={{ alignContent: "end" }}
          >
            <Button
              active={openModal === "LZO"}
              style={{
                padding: "0 10px",
                width: "15vw",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              {dictionary["lzo"]}
            </Button>
          </div>
          <CustomCalendarInput
            label="LZO"
            value={newData.lzoDatum}
            onChange={(v) => handleChange(v, "lzoDatum")}
          />
          <div
            onClick={() => setOpenModal("RIZICI")}
            style={{ alignContent: "end" }}
          >
            <Button
              active={openModal === "RIZICI"}
              style={{
                padding: "0 10px",
                width: "15vw",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              {dictionary["rizici"]}
            </Button>
          </div>
          <div
            onClick={() => setOpenModal("MERE")}
            style={{ alignContent: "end" }}
          >
            <Button
              active={openModal === "MERE"}
              style={{
                padding: "0 10px",
                width: "15vw",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              {dictionary["mereBZR"]}
            </Button>
          </div>
          <div
            onClick={() => setOpenModal("UPUTSTVA")}
            style={{ alignContent: "end" }}
          >
            <Button
              active={openModal === "UPUTSTVA"}
              style={{
                padding: "0 10px",
                width: "15vw",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              {dictionary["uputstva"]}
            </Button>
          </div>
          <CustomSelectMultiple
            allValues={lookups.radna_mesta || []}
            selectedValues={newData.prati}
            onSelectChange={onChangePrati}
            label={dictionary["prati"]}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            height: "40px",
          }}
        >
          <div onClick={() => handleZatvori()} style={{ width: "20%" }}>
            <Button activation={true} style={{ fontWeight: "bold" }}>
              {dictionary["odustani"]}
            </Button>
          </div>
          <div
            onClick={isDisabled ? undefined : handleSacuvaj}
            style={{ width: "20%", opacity: isDisabled ? 0.5 : 1 }}
          >
            <Button
              isDisabled={isDisabled}
              activation={true}
              style={{ fontWeight: "bold" }}
            >
              {dictionary["sacuvaj"]}
            </Button>
          </div>
        </div>

        {openModal === "OPIS" && (
          <OpisModal
            handleCancel={handleCancelModal}
            handleConfirm={(v) => {
              handleChange(v, "opis");
              handleCancelModal();
            }}
            opis={newData.opis}
          />
        )}
        {openModal === "LZO" && (
          <LZOModal
            handleCancel={handleCancelModal}
            handleConfirm={(v) => {
              handleChange(v, "lzo");
              handleCancelModal();
            }}
            lzo={newData.lzo}
            allLzo={lookups.lzo || []}
          />
        )}
        {openModal === "MERE" && (
          <MereModal
            handleCancel={handleCancelModal}
            handleConfirm={(v) => {
              handleChange(v, "mere");
              handleCancelModal();
            }}
            mere={newData.mere}
            allMere={lookups.mere || []}
          />
        )}
        {openModal === "RIZICI" && (
          <RiziciModal
            handleCancel={handleCancelModal}
            handleConfirm={(v) => {
              handleChange(v, "rizici");
              handleCancelModal();
            }}
            rizici={newData.rizici}
          />
        )}
        {openModal === "UPUTSTVA" && (
          <UputstvaModal
            handleCancel={handleCancelModal}
            handleConfirm={(v) => {
              handleChange(v, "uputstva");
              handleCancelModal();
            }}
            uputstva={newData.uputstva}
          />
        )}
      </div>
    </>
  );
}

export default Dodavanje;
